import styled from 'styled-components';

export const StyledImageLink = styled.a`
    display: block;
`;

export const StyledImage = styled.img`
    height: auto;
    width: 100%;
    object-fit: cover;

    &[data-aspect-ratio='true'] {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;
